import { render } from "./PlacesAutocomplete.vue?vue&type=template&id=5f7e1976"
import script from "./PlacesAutocomplete.vue?vue&type=script&lang=js"
export * from "./PlacesAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__